import template from './paylocity-payroll-details.html';
import controller from './paylocity-payroll-details.controller';

let paylocityPayrollDetailsComponent = {
  restrict: 'E',
  template,
  controller
};

export default paylocityPayrollDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll/paylocity-payroll-details.component.js